import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { RouterModule } from '@angular/router'
import { NgbAlertModule } from '@ng-bootstrap/ng-bootstrap'
import { CartCouponModule, CartSharedModule } from '@spartacus/cart/base/components'
import { CmsConfig, FeaturesConfigModule, I18nModule, UrlModule, provideConfig } from '@spartacus/core'
import { CarouselModule, IconModule, MediaModule, PromotionsModule, SpinnerModule } from '@spartacus/storefront'
import { SharedModule } from '../../shared/shared.module'
import { CustomCartSharedModule } from '../cart-shared/custom-cart-shared.module'
import { CustomCartDetailsComponent } from './custom-cart-details.component'
import { CustomCartProductReferencesComponent } from './custom-cart-product-references/custom-cart-product-references.component'

@NgModule({
  declarations: [CustomCartDetailsComponent, CustomCartProductReferencesComponent],
  imports: [
    CartSharedModule,
    CommonModule,
    CartCouponModule,
    RouterModule,
    UrlModule,
    PromotionsModule,
    FeaturesConfigModule,
    I18nModule,
    CustomCartSharedModule,
    CarouselModule,
    MediaModule,
    SpinnerModule,
    NgbAlertModule,
    IconModule,
    SharedModule
  ],
  providers: [
    provideConfig(<CmsConfig>{
      cmsComponents: {
        CartComponent: {
          component: CustomCartDetailsComponent
          // guards: [UserPermissionsGuard],
        }
      }
    })
  ],
  exports: [CustomCartDetailsComponent]
})
export class CustomCartDetailsModule {}
